import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Snackbar, Button } from '@mui/material';
import {
  getNkyAppAlertSx,
  nkyAppSnackbarSx,
  nkySnackbarCloseIgnoringClickaway,
} from '../../../constants/nkyAppSnackbar';

/**
 * Success toast after sending a service inquiry (providers search or business storefront).
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {unknown} props.user — truthy when logged in (shorter duration, no sign-up CTA)
 */
function InquirySentToast({ open, onClose, user }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={user ? 6000 : 12000}
      onClose={nkySnackbarCloseIgnoringClickaway(onClose)}
      sx={nkyAppSnackbarSx}
    >
      <Alert
        onClose={onClose}
        severity="success"
        variant="filled"
        sx={getNkyAppAlertSx('success')}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            width: '100%',
          }}
        >
          <Box
            component="span"
            sx={{
              display: 'block',
              fontWeight: 600,
              fontSize: '0.95rem',
              lineHeight: 1.45,
            }}
          >
            Inquiry sent. The business will receive your details by email.
          </Box>
          {!user ? (
            <Button
              variant="contained"
              fullWidth
              component={RouterLink}
              to="/sign-up"
              size="medium"
              onClick={onClose}
              sx={{
                flexShrink: 0,
                fontWeight: 700,
                textTransform: 'none',
                borderRadius: '10px',
                py: 1,
                bgcolor: '#fff',
                color: '#0D4EFE',
                border: '2px solid rgba(255,255,255,0.95)',
                boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                '&:hover': {
                  bgcolor: '#f0f4ff',
                  color: '#0B3FD4',
                  borderColor: '#fff',
                },
              }}
            >
              Create an account to track requests
            </Button>
          ) : null}
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default InquirySentToast;
